import { AxiosResponse } from "axios";
// LIBS
import { save_file_locally } from "../../../../libs/file_saver";
import { logger } from "../../../../libs/logger";
import { generate_adform_report } from "../../../../libs/node";
import { Data, DownloadReportProps } from "../types";

/**
 * Generates Adform report and downloads it to user's system
 **/
export const downloadAdformReport = async ({ scope, id, metrics, dateFrom, dateTo, name, user, notificationDispatch, mediaLoadingDispatch }: DownloadReportProps) => {
  mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: true, type: "delete", message: "Requesting Report...", progress: Math.floor(Math.random() * (50 - 41 + 1) + 41) } });
  try {
    /* Makes POST request to our report generation API */
    const adformReport: AxiosResponse<Data> = await generate_adform_report({ scope, id, metrics, dateFrom, dateTo });
    /* Downloads each report as a CSV file
     * If data exists, adformReport.data.payload.reports will be an array
     * If not, then output message to user that no data exists for the provided date range
     */
    adformReport.data.payload.reports.forEach((report, i) => {
      save_file_locally(`data:text/csv;charset=utf-8,${report}`, `${name}-${i === 1 ? "events-" : ""}report-${dateFrom}-${dateTo}.csv`);
    });
    mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: false, type: "", message: "", progress: 0 } });
    notificationDispatch({
      type: "ADD",
      payload: {
        header: "Success",
        message: "Report downloaded",
        type: "success",
        autoDismiss: true,
      },
    });
  } catch (error) {
    logger({ error, user, context: { origin: "downloadAdformReport_downloadAdformReport" } });
    mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: false, type: "", message: "", progress: 0 } });
    notificationDispatch({
      type: "ADD",
      payload: {
        header: "Error",
        message: `No data exists for requested ${scope} for the provided date range`,
        type: "error",
        autoDismiss: false,
      },
    });
    return error;
  }
};
